import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { AddStaffService } from '../../services/add-staff.service';
import { MatTableDataSource } from '@angular/material/table';
import { StaffMemberUpload } from '../../../../models/StaffMemberUpload';
import { tap } from 'rxjs/operators';
import { GoogleAnalyticsService } from '../../../../../services/googleanalytics.service';
import { GoogleAnalyticsEvents } from '../../../../../models/GoogleAnalyticsEvents';
import { MatDialogRef } from '@angular/material/dialog';
import { AddStaffDialogComponent } from 'src/app/base-layout/components/toolbar/add-staff-dialog/add-staff-dialog.component';
/**
 * UploadStaffComponent has @Output() validState which when file is uploaded successfully emitst true value otherwise emits false.
 */

@Component({
  selector: 'app-upload-staff',
  templateUrl: './upload-staff.component.html',
  styleUrls: ['./upload-staff.component.scss']
})
export class UploadStaffComponent implements OnInit {
  @Input() usedInsideApp: boolean;
  @Output() validState: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() addStaff: EventEmitter<number> = new EventEmitter<number>();
  @Output() file: EventEmitter<string | ArrayBuffer> = new EventEmitter<string | ArrayBuffer>();

  dataSource: MatTableDataSource<StaffMemberUpload>;
  loading = false;
  isError = false;
  errorList: string[];
  currentStep = 11;
  filename: string;

  private _analyticsEvents = new GoogleAnalyticsEvents();

  constructor(private _addStaffService: AddStaffService, private _cdr: ChangeDetectorRef,
    private _analyticsService: GoogleAnalyticsService,
    @Optional() public dialogRef: MatDialogRef<AddStaffDialogComponent>) {
  }

  ngOnInit(): void {
    this.getUploadData();

  }

  private fileUpload() {
    return this._addStaffService.uploadFile().pipe();
  }

  private _updateGoogleAnalytics() {
    this._analyticsService.eventEmitter(this._analyticsEvents.onboarding.category,
      this._analyticsEvents.onboarding.action.upload_csv_template.name,
      this._analyticsEvents.onboarding.action.upload_csv_template.label);
  }

  private _manageErrorMessages(response: any) {
    this.errorList = [];
    const rowNumbers: number[] = [];
    if (String(response.code) === '422') {
      response?.data?.forEach(item => {
        if (rowNumbers.indexOf(item.rownumber) === -1) {
          const error = `<b class="err-row-width">Row  ${item.rownumber} Error: </b> ${item.errormessage}.`;
          this.errorList.push(error);
        }
      });
    }
  }

  /**
   * Go back to add staff page
   */
  backButtonClick(pageNumber: number): void {
    this.addStaff.emit(pageNumber);
  }

  checkIfValid(event) {
    this.validState.emit(event);
  }
  acceptFile(file) {
    this.file.emit(file);
    this.getUploadData();
  }
  setFileName(fileName: string) {
    this._addStaffService.fileName = fileName;
  }


  getUploadData() {
    this.loading = true;
    this.filename = this._addStaffService.fileName;
    this.fileUpload().pipe(
      tap(e => this._updateGoogleAnalytics())
    ).subscribe(response => {
      if (!!String(response.code).match(/200|201/)) {
        this._addStaffService.staffMembers = response.data;
        this.dataSource = new MatTableDataSource(response.data);
        this.isError = false;
      } else {
        this.isError = true;
        this._manageErrorMessages(response);
      }
      this.loading = false;
    }, error => {
      this.loading = false;
      this.isError = true;
      this._manageErrorMessages(error.error);
    });
  }

}
